<template lang="html">
  <div class="tabs">
    <ul class="tabs__header" :style="headerInlineStyles">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        :class="[{ tabs__tab_selected: index == selectedIndex }, `tabs__tab`]"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    headerInlineStyles: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedIndex: 0,
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  emits: ["select-tab"],
  methods: {
    selectTab(i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
      this.$emit("select-tab", this.tabs[i].title);
    },
  },
};
</script>

<style scoped>
.tabs__tab {
  font-size: 1.5rem;
  color: #337ab7;
}

.tabs__header li:hover {
  transition: 0.3s;
  opacity: 0.5;
  cursor: pointer;
}

.tabs__header {
  padding: 0;
  display: inline-flex;
  flex-direction: row;
  column-gap: 1em;
  list-style-type: none;
}

.tabs__tab_selected {
  --primary-color: #01315a;
  color: var(--primary-color);
  font-weight: 500;
  opacity: 0.5;
  pointer-events: none;
}

@media (max-width: 767px) {
  .tabs__header {
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  .tabs__header > * + * {
    margin-top: 1em;
    margin-left: 0;
  }
}

@media (max-width: 767px) {
  .tabs__tab {
    font-size: 16px;
  }
}

@media (max-width: 1279px) {
  .tabs__tab {
    font-size: 1.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Tabs.vue